import React from "react";

import AsyncComponent from "components/AsyncComponent";
import Loader from "components/Loader";
import SplashBanner from "components/splash/SplashBanner";
import PlainThingListItem from "components/thing/PlainThingListItem";
import things from "services/things";
import {editThing} from "services/views";
import {TOAST_SHOWN} from "state/actions";

export default class SearchResults extends AsyncComponent {
  get service() {
    return things(this.props.store);
  }

  get isSearching() {
    return this.service.searchOngoing();
  }

  edit(thing) {
    return () =>
      editThing(
        this.props.store,
        this.props.namespace.schemas.find(({id}) => id === thing.schemaId),
        thing
      );
  }

  handleError() {
    const {store} = this.props;
    TOAST_SHOWN.dispatch(store, {
      icon: "danger",
      text: "Hubo un problema para obtener más resultados; inténtelo más tarde",
      timeout: 5000,
    });
  }

  renderFooter() {
    const complete = !this.service.searchIncomplete();
    const disabled = complete || this.isSearching;
    return (
      <div className="px-3">
        <button
          type="button"
          className="btn btn-light btn-block btn-lg"
          disabled={disabled}
          onClick={() => {
            const phrase = this.props.store.getState(
              "resource",
              this.service.searchKey(),
              "data",
              "phrase"
            );
            this.service.search(phrase).catch(this.async(this.handleError));
          }}
        >
          {complete ? "—" : "Cargar más"}
        </button>
      </div>
    );
  }

  renderResults({phrase, total, items}) {
    if (total === 0) {
      return <p className="lead mt-1 text-center">No se encontraron resultados.</p>;
    }
    return (
      <>
        {items.map((item, index) => (
          <PlainThingListItem
            thing={item}
            namespace={this.props.namespace}
            first={index === 0}
            last={index === items.length - 1}
            onClick={this.edit(item).bind(this)}
          />
        ))}
        {this.renderFooter()}
      </>
    );
  }

  render() {
    const resource = this.props.store.getState(
      "resource",
      this.service.searchKey(),
      "data"
    );
    return (
      <>
        {this.isSearching && <Loader />}
        {resource ? this.renderResults(resource) : <SplashBanner />}
      </>
    );
  }
}
